import React from 'react';
import {Icons} from '@learningblocks/exp-constants';

const {ChevronDownSolid: ChevronSolid} = Icons;

export function DownIcon(props) {
  return <ChevronSolid className={props.className} />;
}

export function UpIcon(props) {
  return (
    <ChevronSolid
      className={props.className}
      style={{
        transform: 'rotate(180deg)',
      }}
    />
  );
}

export function LeftIcon(props) {
  return (
    <ChevronSolid
      className={props.className}
      style={{
        transform: 'rotate(90deg)',
      }}
    />
  );
}

export function RightIcon(props) {
  return (
    <ChevronSolid
      className={props.className}
      style={{
        transform: 'rotate(-90deg)',
      }}
    />
  );
}
